import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import Reveal from '../Reveal/Reveal'
import { LanguageContext } from '../LanguageSwitcher/LanguageContext'
import articles from '../../data/articles'
import articleSummaries from '../../data/articleSummaries'
import { LEGACY_ARTICLE_TITLE_KEYS } from '../../data/topicArticles'
import { localizeArticle } from '../../pages/articles/articlePage/articleShared'

/**
 * "Further reading" cards on service and industry pages: plain <a href>
 * links into /articles, so crawlers reach every article from the pages
 * that rank, not only from the blog index.
 */
const RelatedArticles = ({ ids }) => {
  const { translations } = useContext(LanguageContext)

  const items = (ids || [])
    .map((id) => {
      const source = articles.find((article) => article.slug === id)
      const title = source
        ? localizeArticle(source, translations).title
        : translations[LEGACY_ARTICLE_TITLE_KEYS[id]]
      if (!title) return null
      const summary = translations[`artSum.${id}.0`] || (articleSummaries[id] || [])[0]
      return { id, title, summary }
    })
    .filter(Boolean)

  if (items.length === 0) return null

  return (
    <section className='svc-section svc-related-section'>
      <div className='svc-inner'>
        <Reveal>
          <h2 className='svc-display svc-display-sm'>{translations.svcReadingTitle || 'Further reading'}</h2>
        </Reveal>
        <div className='svc-related'>
          {items.map((item, index) => (
            <Reveal key={item.id} delay={index * 0.08} className='svc-related-wrap'>
              <Link to={`/articles/${item.id}`} className='svc-link-card'>
                <h3 className='svc-card-title'>{item.title}</h3>
                {item.summary && <p className='svc-card-text'>{item.summary}</p>}
                <span className='svc-link-more'>{translations.svcReadArticle || 'Read the article'} <span aria-hidden='true'>→</span></span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  )
}

export default RelatedArticles
